<template>
  <card titulo="Histórico">

    <auditoria-pagination :referencia="pessoa.indicadorPessoalId" entidade="INDICADOR_PESSOAL_VERSAO" />

  </card>
</template>

<script>
  import Card from "@/components/Layout/components/Card.vue";
  import AuditoriaPagination from "@/v2/components/Auditoria/AuditoriaPagination.vue";

  export default {

    name: "Histórico",
    components: {Card, AuditoriaPagination},
    props: {
      pessoa: Object
    },

    data() {
      return {
        historico : [],
        loading: true,
        disable: false,
        page: 1,
        pageSize: 10
      }
    },

    methods:{}
  }
</script>
